export { default as SpiderWeb } from './component'
